import { useMutation } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices";
import type { SearchQueryBody } from "@/types";

interface RoboqlMutationVariables {
  query: string;
  /**
   * Caller-resolved org id, forwarded to the convert endpoint as the
   * `X-Roboto-Org-Id` header.
   */
  orgId: string | undefined;
}

export function useConvertRoboqlToSpecMutation() {
  const { queryService } = useDomainServices();
  return useMutation<SearchQueryBody, Error, RoboqlMutationVariables>({
    mutationFn: ({ query, orgId }) =>
      queryService.convertRoboqlToSpec(query, { orgId }),
  });
}
